module.exports = __webpack_public_path__ + "static/img/publice_logo.522c5821.png";